var React = require('react');

function TextBoxFlag2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m51.5540168 627.823888 729.0143502-420.383043 215.781408 144.656765-827.501249 478.716562z","fill":"#4eb684","fillRule":"evenodd","opacity":".084938","transform":"matrix(.8660254 .5 -.5 .8660254 194.759998 -569.42605)"}));
}

TextBoxFlag2.defaultProps = {"height":"235","viewBox":"0 0 882 235","width":"882"};

module.exports = TextBoxFlag2;

TextBoxFlag2.default = TextBoxFlag2;
